

<!--Main Navigation-->
<header class="headerClass">
  <!-- Top black navbar -->
  <nav class="navbar navbar-expand-lg navbar-light bg-black navbar-backgroundBlack">
    <div class="navbar navbar-expand-lg navbar-light logoContainerNav" >
      <img src="../assets/img/frankylogo.svg" class="frankylogo" alt="Frranky Logo">
    </div>
  </nav>

  <!-- White navigation bar -->
  <nav class="navbar navbar-expand-lg navbar-light bg-white whiteNavbar" style="height:33px;">
    <div class="col container-fluid">
      <!-- <button class="navbar-toggler mobileButton" (click)="toggleDropdown()" type="button" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button> -->
         <button class="navbar-toggler mobileButton" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent" #mobileMenu>
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 menuDropdownList" [class.show]="isOpen">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="#">Home</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link" style="cursor: pointer;">Men</a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" (click)="menOversizedPlain()">Oversized Plain T-Shirts</a></li>
              <li><a class="dropdown-item" (click)="menOversizedPrinted()">Oversized Printed T-Shirts</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link" style="cursor: pointer;">Women</a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" (click)="womenOversizedPlain()">Oversized Plain T-Shirts</a></li>
              <li><a class="dropdown-item" (click)="womenOversizedPrinted()">Oversized Printed T-Shirts</a></li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" style="cursor: pointer;" (click)="newArrivalsFn()">New Arrivals</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" style="cursor: pointer;" (click)="bestSellersFn()">Best Sellers</a>
          </li>
        </ul>
      </div>

      <div class="d-flex align-items-center">
        <!-- Search -->
        <div class="header-search d-inline-flex align-items-center" [class.open]="isSearchOpen">
          <button class="btn" type="button" (click)="toggleSearch($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
            </svg>
          </button>
          <input id="headerSearchInput" *ngIf="isSearchOpen" type="text" 
                 class="form-control search-input ms-2" 
                 placeholder="Search products" 
                 [(ngModel)]="searchQuery" 
                 (keyup.enter)="performSearch()" 
                 (click)="$event.stopPropagation()" />
          <button *ngIf="isSearchOpen && searchQuery" 
                  class="btn btn-outline-secondary clear-btn ms-2" 
                  type="button" 
                  (click)="clearSearch(); $event.stopPropagation()" 
                  title="Clear">✕</button>
        </div>

        <!-- Cart -->
        <button class="btn" type="button" (click)="viewCartButton()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cart" viewBox="0 0 16 16">
            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
          </svg>
        </button>

        <!-- User -->
        <button class="btn" type="button" (click)="loginButton()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"/>
          </svg>
        </button>
      </div>
    </div>
  </nav>

  <!-- Sidebar that opens on user button click -->
<div *ngIf="isOpenLogin && notCart" class="sidebar" [class.open]="isOpenLogin" >
    <button class="close-btn" (click)="toggleSidebar()" >✕</button>

    <!-- Sidebar Menu -->
    <nav class="sidebar-menu" >
      <!-- User actions -->
      <!-- <div class="menu-section"> -->
        <a routerLink="/login" class="menu-item" (click)="loginButtonFn();">
          <span class="menu-icon">🔑</span>
          <span class="menu-text">Login</span>
        </a>
        <a routerLink="/viewCart" class="menu-item" (click)="viewCartButton(); ">
          <span class="menu-icon">🛒</span>
          <span class="menu-text">Cart</span>
        </a>
        <a routerLink="/account" class="menu-item" (click)="accountPageFn();">
          <span class="menu-icon">�</span>
          <span class="menu-text">Account</span>
        </a>
        <a routerLink="/order" class="menu-item" (click)="ordersPageFn();">
          <span class="menu-icon">📦</span>
          <span class="menu-text">Orders</span>
        </a>
         <a  class="menu-item" style="cursor: pointer;" (click)="logoutAuthFn();">
          <span class="menu-icon">🔑</span>
          <span class="menu-text">Logout</span>
        </a>
      <!-- </div> -->
    </nav>
  </div>
</header>

<main class="main-content">
<router-outlet></router-outlet>
</main>

  <footer class="bd-footer py-4 py-md-5 mt-5">
          <div style="padding-left: 30px;">
            <div class="row">
              <!-- Left Section -->
              <div class="col-md-4 col-sm-12" style="padding-left: 0px;padding-right: 35px;">
                <h5>Get to Know Us</h5>
                <p>About Us</p>
                <p>Contact Us</p>
                <p>
                  <img class="callIcon" src="../assets/img/callicon.svg" >
                 
                  Ph - 9811308821
                </p>
                <p>
                  <img class="whatsappIcon" src="../assets/img/email.svg">
                  Email - harshit@gmail.com
                </p>
              </div>
        
              <!-- Center Section -->
              <div class="col-md-4 col-sm-12 text-center" style="padding-left: 0px;padding-right: 35px;">
                <h5>Our Policies</h5>
                <p (click)="privacyPolicyFn()" style="cursor: pointer;">Privacy Policy</p>
                <p (click)="returnExchangeFn()" style="cursor: pointer;">Return/Exchange</p>
                <p (click)="termsOfServiceFn()" style="cursor: pointer;">Terms Of Service</p>
                <p (click)="shippingPolicyFn()" style="cursor: pointer;">Shipping Policy</p>
              </div>
        
              <!-- Right Section -->
              <div class="col-md-4 col-sm-12" style="padding-left: 0px;padding-right: 35px;">
                <h5 class="stayConnectedHeading">Stay Connected</h5>
                <div class="stayConnectedImagesDiv">
                  <!-- <img class="instaIcon" src="../../assets/img/instagram.svg" href="https://www.instagram.com/frranky.in/"> -->
                  <a href="https://www.instagram.com/frranky.in/" target="_blank">
                    <img class="instaIcon" src="../assets/img/instagram.svg" alt="Instagram Icon">
                  </a>
                  <a href="https://www.facebook.com/frranky.in" target="_blank">
                    <img class="fbIcon" src="../assets/img/facebook.svg" >
                  </a>
                  <a href="https://www.linkedin.com/company/105905297/admin/dashboard/" target="_blank">
                    <img class="linkedinIcon" src="../assets/img/linkedin.svg">
                  </a>
                  <a href="http://wa.me/919811308821" target="_blank">
                    <img class="whatsappIcon" src="../assets/img/whatsapp.svg">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>